// extracted by mini-css-extract-plugin
export const headerFixedHomePage = "index-modules--headerFixedHomePage--1RR3o";
export const headerFixedHomePageScrolled = "index-modules--headerFixedHomePageScrolled--Nq0C5";
export const headerFixed = "index-modules--headerFixed--bFF5j";
export const mobMenu = "index-modules--mobMenu--QlD5Q";
export const inCircle = "index-modules--inCircle--36oE-";